<template>
  <div class="mainList">
    <div class="title-top">
      <form action="/" ref="toggle1">
        <van-search
          v-model="value"
          placeholder="请输入你要搜索的内容"
          shape="round"
          @search="onSearch()"
        />
      </form>
      <div class="hidden" ref="toggle">
        <p>小频正在努力完善......敬请期待！</p>
        <p>如需要更多帮助，请直接拨打热线咨询：</p>
        <p>热线1：021-54281738</p>
        <p>热线2：400-827-0866</p>
      </div>
      <div class="main_contain" v-for="item in info" :key="item.id">
        <span class="info_left">
          <img src="@assets/images/txt_2.png" alt="" />
        </span>
        <span class="name_middle">{{ item.title }}</span>
        <button class="downLoad">
          <a :href="item.src">下载</a>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { baseInfo } from "@utils/config.js";
import { searchData } from "@api/common";
import { getword } from "@api/common";

export default {
  data() {
    return {
      info: [],
      zid: "",
      value: ""
    };
  },
  created() {
    const zid = location.href.split("=")[1];
    // console.log(zid);
    this.zid = zid;
    // console.log(this.zid);
    this.getDataInfo(location.href.split("=")[1]);
  },
  methods: {
    onSearch() {
      searchData({
        zid: this.zid,
        keyword: this.value
      }).then(res => {
        // console.log(res);
        this.info = res.data;
      });
    },
    getDataInfo(id) {
      getword({ zid: id }).then(res => {
        console.log(res);
        this.info = res.data;
        if (this.info.length > 0) {
          this.$refs.toggle.style.display = "none";
          this.$refs.toggle1.style.display = "block";
        } else {
          this.$refs.toggle.style.display = "block";
          this.$refs.toggle1.style.display = "none";
        }
      });
    }
  },
  computed: {
    getWebSoketDomain() {
      return baseInfo.webSoketDomain;
    }
  }
};
</script>
<style lang="scss" scoped>
.main_contain {
  //   margin-top: 20px;
  width: 93%;
  height: 1.1rem;
  background-color: #fff;
  margin: 0.3rem auto;
  padding-top: 0.4rem;
  padding-left: 0.2rem;
  padding-right: 0.4rem;
  .info_left {
    img {
      width: 0.4rem;
      height: 0.5rem;
      vertical-align: top;
      margin-right: 0.3rem;
    }
  }
  .name_middle {
    font-family: SourceHanSansCN-Normal;
    font-size: 0.3rem;
    height: 0.5rem;
    line-height: 0.5rem;
    color: #333333;
  }
  .downLoad {
    background: #4c84ff;
    border-radius: 0.3rem;
    width: 1.3rem;
    height: 0.45rem;
    float: right;
    a {
      font-family: SourceHanSansCN-Normal;
      font-size: 0.22rem;
      color: #ffffff;
    }
  }
}
.hidden {
  width: 7rem;
  height: 3rem;
  margin: 3rem auto;
  padding: 0.2rem;
  display: none;
  p {
    font-weight: 700;
    margin: 0.4rem 0;
    text-align: center;
  }
}
</style>
